import { Grid, Link } from "@mui/material";
import React, { useEffect } from "react";
import AOS from 'aos';
import 'aos/dist/aos.css'
import linkedin from "../../images/linkedin.png"

const TeamCards = (props) => {
    // let box = document.querySelector('.MS--img-container');
    // let boxWidth = 0;
    // let boxHeight = 0;
    // boxWidth = box.offsetWidth;
    // boxHeight = box.offsetHeight;
    useEffect(() =>{
        AOS.init({duration: 2000})
    })
    return(
        <Grid 
            xs={12}
            sm={6}
            md={3}
            className="px-3 my-4"
            data-aos={props.cardAnimate}
        >
            <div className="MS---Team_card d-block mx-auto">
                <div className="MS--img-container position-relative">
                    <img src={props.cardImg} className="img-fluid" />
                </div>
                <div className="MS--content-container py-4 px-4 text-left">
                    <p className="text-left mb-0" style={{fontSize:12,color: '#878E86'}}>{props.personName}</p>
                    <h3 className="text-left">{props.title}</h3>
                    <div className="MS---socialMedia">
                        <Link href={props.socialLink} className="d-inline-block" style={{padding: "2px 3px"}} target="_blank">
                            <img src={linkedin} style={{width: 15, height: 15, marginTop: "-3px"}} />
                        </Link>
                    </div>
                    <div className="bg"></div>
                </div>
            </div>
        </Grid>
    );
}

export default TeamCards;